import { render, staticRenderFns } from "./CorporateStaffDashboardMP.vue?vue&type=template&id=310b7b08&scoped=true&"
import script from "./CorporateStaffDashboardMP.vue?vue&type=script&lang=ts&"
export * from "./CorporateStaffDashboardMP.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateStaffDashboardMP.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./CorporateStaffDashboardMP.vue?vue&type=style&index=1&id=310b7b08&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b7b08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
